<template>
    <div class="tooltip" ref="tooltip">
        <tooltipIcon class="tooltip-img" @click.native="openToolTip"/>
        <tooltipBlock v-if="showToolTip" v-click-outside-component="closeToolTip" :indexData="indexData" :loading="tooltipLoading" :closeToolTip="closeToolTip"/>
    </div>
</template>

<script>
import axios from 'axios'
import tooltipIcon from './tooltipIcon.vue'
import tooltipBlock from './tooltipBlock.vue'

export default {
    name: 'tooltip',
    props: ['ogrn'],
    components: {
        tooltipIcon,
        tooltipBlock
    },
    data() {
        return {
            showToolTip: false,
            indexData: null,
            tooltipLoading: false
        }
    },
    methods: {
        closeToolTip() { this.showToolTip = false },
        openToolTip() {
            this.getCompanyIndexData()
            this.showToolTip = true
        },
        getCompanyIndexData() {
            if(!this.indexData) {
                this.tooltipLoading = true
                axios({
                    url: `${process.env.API_PRO}/company/${this.$props.ogrn}/index`,
                    headers: {
                        Authorization: `Bearer ${window.apiSession}`
                    }
                }).then(e => {
                    if(e.data.status.code == 200) {
                        this.indexData = e.data.data
                    }
                }).finally(() => {
                    this.tooltipLoading = false
                })
            } else {
                this.tooltipLoading = false
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@use 'styles/mobile.sass'
@import 'styles/global-variables.sass'

.tooltip
    position: relative
    display: inline-block
    white-space: initial
</style>